import React, { Component } from "react"
import config from "react-global-configuration"
import { getContentEnrichedProduct } from "../../helpers/bookingHelper"
import * as tracking from "../../../booking/helpers/tracking"
import Svg from "../../../shared/_svgs/svg"

class MapMarkerParking extends Component {
  handleSpecialProductClick = () => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(this.props.item, this.props.content),
    })
  }

  handleMemberProductClick = () => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingMemberProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(this.props.item, this.props.content),
    })
  }

  handleClickFunction = (isSpecialProduct, showMemberprice, isLoggedIn, product, carPark) => {
    //tracking.trackParkingEngagementClick('parking - map', `gå til booking - click - ${product.name} ${carPark.name}`)
    if (isSpecialProduct) {
      this.handleSpecialProductClick()
    } else if (showMemberprice && !isLoggedIn) {
      this.handleMemberProductClick()
    } else {
      this.props.handleReservation(product.id, this.props.item, this.props.handleBuyMemberProductCleanup, this.props.isAmendment)
    }
  }

  handlePinClick = (product) => {
    tracking.trackParkingEngagementClick("parking - map", `pin - click - ${product.name}`)
  }

  renderPrice(noOriginalPrice, originalPrice, totalPrice) {
    if (!noOriginalPrice) {
      if (originalPrice > totalPrice) {
        return true
      }
      return false
    }
    return false
  }

  render() {
    const { globals, isAmendment = false, changeFromBooking = undefined } = this.props
    const { product, carPark, result } = this.props.item
    const textKeys = config.get("textKeys.parkingList.listElement") || {}
    const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
    const { userAccountDetails } = this.props
    // if (product.isSoldOut && !this.props.isInModal) return null

    //membercheckup.
    const isLoggedIn = !!userAccountDetails
    const changeFromLoggedIn = !!this.props.changeFromBooking?.booking?.membershipNumber
    const hasLoggedInInfo = !!(isLoggedIn || changeFromLoggedIn)

    //Generating a variable so we can detect which carpark is our current carpark for amendment flow.
    let matchingBooking = false
    if (isAmendment) {
      if (changeFromBooking.booking?.carParkId === this.props.item.carPark.id) {
        matchingBooking = true
      }
    }
    let membershipCarParks = [77, 71]

    //Product setting variables.
    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice
    const membershipCarParksCheck = membershipCarParks.includes(carPark?.id) && result?.memberPrice === 0
    const isMembershipCarpark = membershipCarParks.includes(carPark?.id)
    let showMembershipPriceLabel = false

    showMembershipPriceLabel = !membershipCarParksCheck && !hasLoggedInInfo ? true : false

    if (!isMembershipCarpark) {
      showMembershipPriceLabel = false
    }

    //product pricing variable for amendmentflow
    let changeFromBookingPrice = 0
    if (changeFromBooking) {
      changeFromBookingPrice = changeFromBooking.booking.items.parkings[0].amount
    }

    //Generating variables to conditionally render + in front of positive amendment prices.
    let positiveMemberPrice
    let positiveTotalPrice
    if (isAmendment) {
      positiveMemberPrice = result.memberPrice - changeFromBookingPrice > 0 ? "+" : ""
      positiveTotalPrice = result.totalPrice - changeFromBookingPrice > 0 ? "+" : ""
    }

    let promotionBanner =
      result.originalPrice > result.totalPrice && globals.promotionName
        ? globals.promotionName
        : result && result.thirdPartyPromoLabelText
          ? result.thirdPartyPromoLabelText
          : product.dynamicFields && product.dynamicFields.calloutBanner
            ? product.dynamicFields.calloutBanner
            : undefined

    // use affiliateBanner if an affiliateCode is active
    const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
    if (affiliateCheck) {
      promotionBanner = product.dynamicFields.affiliateBanner
    }

    let bubbleColor = product.dynamicFields.productColor
    if (
      carPark.code !== "P4S" &&
      result?.thirdPartyPromoLabelColorCode &&
      !affiliateCheck &&
      (result.showOriginalPrice || result.showPayOnFootPrice) &&
      !(result.originalPrice > result.totalPrice && globals.promotionName)
    ) {
      bubbleColor = result.thirdPartyPromoLabelColorCode
    } else if (carPark.code !== "P4S" && (result.showOriginalPrice || result.showPayOnFootPrice || affiliateCheck)) {
      bubbleColor = "#fecb00"
    }

    if (product.dynamicFields && product.dynamicFields.productLeftV2 && product.dynamicFields.productTopV2) {
      // only render markers that have a position
      return (
        <div
          className={`map-marker map-marker--parking ${matchingBooking ? "map-current" : ""} ${this.props.isInModal ? "is-disabled" : ""} ${
            product.isSoldOut ? "map-marker--soldout" : ""
          }`}
          data-center={this.props.isCenter || this.props.isSingle ? true : false}
          data-positionstyle={`left:${product.dynamicFields.productLeftV2}%;top:${product.dynamicFields.productTopV2}%;`}
          data-positionx={product.dynamicFields.productLeftV2}
          data-positiony={product.dynamicFields.productTopV2}
          onClick={() => this.handlePinClick(product)}
        >
          <div className="bubble" style={{ backgroundColor: product.isSoldOut ? "#a4a8ad" : bubbleColor }}>
            {product.categoryName && product.categoryName.startsWith("We Park You Fly") ? (
              <React.Fragment>
                <span className="icon">
                  <svg className="svg-icon svg-icon--keypickup">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-keypickup">
                      &nbsp;
                    </use>
                  </svg>
                </span>
                <strong>×</strong>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>{carPark.name}</span>
                <strong>×</strong>
              </React.Fragment>
            )}
          </div>
          {result ? (
            <div className="label">
              <span className="label__inner">
                <strong className={isAmendment ? "amendment-label" : ""}>
                  {isAmendment
                    ? showMemberprice
                      ? result.memberOriginalPrice - changeFromBookingPrice > 0
                        ? "+"
                        : ""
                      : result.totalPrice - changeFromBookingPrice > 0
                        ? "+"
                        : ""
                    : ""}

                  {this.props.priceFormatter(
                    isAmendment
                      ? showMemberprice
                        ? result.memberOriginalPrice - changeFromBookingPrice
                        : result.totalPrice - changeFromBookingPrice
                      : result.totalPrice,
                  )}
                  {matchingBooking ? (
                    <div className="check-container">
                      <Svg iconName={"checkmark"} fillColor={"#000"} />
                    </div>
                  ) : (
                    ""
                  )}
                </strong>
              </span>
            </div>
          ) : null}
          {!this.props.isInModal ? (
            <div className="content">
              <div className="content__inner">
                {promotionBanner ? (
                  <span className="angled-ribbon angled-ribbon--map-marker map-marker--parking">
                    <span
                      className="angled-ribbon__inner"
                      style={{
                        backgroundColor:
                          !affiliateCheck &&
                          !(result.originalPrice > result.totalPrice && globals.promotionName) &&
                          result.thirdPartyPromoLabelColorCode
                            ? result.thirdPartyPromoLabelColorCode
                            : null,
                      }}
                    >
                      <span className="text">{promotionBanner}</span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
                <div className="details">
                  <div className="title">
                    <h4>
                      {product.name} <em>{carPark.name}</em>
                    </h4>
                  </div>
                  <div className="features">
                    {carPark.transferMethod === "Bus" ? (
                      <p>
                        <svg className="svg-icon svg-icon--bus">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-bus"></use>
                        </svg>
                        <span>
                          {carPark.transferTime} {textKeys.busTime || "min. i bus til terminalen"}
                        </span>
                      </p>
                    ) : (
                      <p>
                        <svg className="svg-icon svg-icon--bus">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-passenger"></use>
                        </svg>
                        <span>
                          {carPark.transferTime} {textKeys.walkTime || "min. gang til terminalen"}
                        </span>
                      </p>
                    )}
                    {product.dynamicFields && product.dynamicFields.productValet ? (
                      <p>
                        <svg className="svg-icon svg-icon--keypickup">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-keypickup"></use>
                        </svg>
                        <span>{textKeys.indoorDeliverOutdoorParking || "Indendørs aflevering - udendørs parkering"}</span>
                      </p>
                    ) : carPark.transferFrequency === 1 ? (
                      <p>
                        <svg className="svg-icon svg-icon--sun">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
                        </svg>
                        <span>{textKeys.outdoorParking || "Udendørs parkeringsanlæg"}</span>
                      </p>
                    ) : carPark.transferFrequency === 2 ? (
                      <p>
                        <svg className="svg-icon svg-icon--sun">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-carindoors"></use>
                        </svg>
                        <span>{textKeys.indoorParking || "Indendørs parkeringsanlæg"}</span>
                      </p>
                    ) : carPark.transferFrequency === 3 ? (
                      <p>
                        <svg className="svg-icon svg-icon--sun">
                          <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
                        </svg>
                        <span>{textKeys.in_outdoorParking || "Inden- og udendørsparkering"}</span>
                      </p>
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: `<!-- ${JSON.stringify(carPark)} -->` }} />
                    )}
                  </div>
                </div>
                {result ? (
                  <div className="price">
                    <span className="price__inner">
                      {isAmendment ? (
                        <div>
                          {<h6> {isMembershipCarpark ? textKeys.memberPrice : ""}</h6>}
                          <h5>
                            <strong>
                              {result.showMemberPrice ? positiveMemberPrice : positiveTotalPrice}
                              {this.props.priceFormatter(
                                result.showMemberPrice ? result.memberPrice - changeFromBookingPrice : result.totalPrice - changeFromBookingPrice,
                              )}
                            </strong>
                          </h5>

                          <p>
                            {textKeys.totalPrice || "Total: "}{" "}
                            {this.props.priceFormatter(result.showMemberPrice ? result.memberPrice : result.totalPrice)}
                          </p>
                        </div>
                      ) : (
                        <div>
                          <h6>{result.showMemberPrice ? textKeys.memberPrice : textKeys.onlinePrice || "Onlinepris: "}</h6>
                          <h5>
                            <strong>{this.props.priceFormatter(result.showMemberPrice ? result.memberPrice : result.totalPrice)}</strong>
                          </h5>
                          {result.showMemberPrice ? (
                            <p className={hasLoggedInInfo ? "price-line-through " : null}>
                              {textKeys.nonMemberPrice} <span>{this.props.priceFormatter(result.totalPrice)}</span>
                            </p>
                          ) : (
                            ""
                          )}
                          {result?.showPayOnFootPrice ? (
                            <p>
                              {textKeys.normalOnlinePrice || "Normal onlinepris:"}{" "}
                              <span className={"line-through"}>{this.props.priceFormatter(result.payOnFootPrice)}</span>
                            </p>
                          ) : (
                            ""
                          )}
                          {result?.showOriginalPrice ? (
                            <p>
                              {textKeys.previousPrice || "Førpris:"}{" "}
                              <span className={"line-through"}>{this.props.priceFormatter(result.originalPrice)}</span>
                            </p>
                          ) : (
                            ""
                          )}
                          {result?.showDriveInPrice ? (
                            <p>
                              {textKeys.drivePrice || "Drive in-pris:"} <span className={""}>{this.props.priceFormatter(result.barrierTariff)}</span>
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </span>

                    {!this.props.disableReservation ? (
                      product.isSoldOut ? (
                        <button className="button button--small button--general is-disabled">
                          <span className="text">
                            {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed
                              ? wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"
                              : textKeys.soldOut || "Udsolgt"}
                          </span>
                        </button>
                      ) : (
                        /*
                                                <button className={
                                                    isSpecialProduct ? 
                                                    "button button--small button--general" :
                                                    "button button--small button--general js--mobile-deactivate"}
                                                onClick={handleClickFunction}>
                                            */
                        <button
                          className="button button--small button--general js--mobile-deactivate"
                          onClick={() => this.handleClickFunction(isSpecialProduct, showMemberprice, hasLoggedInInfo, product, carPark)}
                        >
                          <span className="text">{textKeys.reserve || "Reservér"}</span>
                        </button>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      )
    }
    return null
  }
}
export default MapMarkerParking
